import { API_URL } from '../Config.js';

const apiUrl = API_URL 

const getFrmParamsLista = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetFrmConfig`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const UpdateFrmParam = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmUpdateFrmConfig`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        //.then(data => {return data})
        .catch(error => { });

}

export {getFrmParamsLista, UpdateFrmParam}